import { Box, Typography, useTheme } from "@mui/material";

export const FieldError = ({ error }: { error?: any }) => {
  const theme = useTheme();
  return (
    <Box
      style={{
        marginTop: "4px",
        color: theme.palette.error.main,
        fontSize: "0.8em",
        minHeight: "20px",
      }}
    >
      <Typography variant="caption"> {error?.message}</Typography>
    </Box>
  );
};
